export const coreMobileEn = {
    
    TOAST: {
        DISPENSAR: "Dismiss",
        AGUARDE: "Wait"
    },
    COMMON: {
        CLOSE: "Close",
        INPUTIMAGE: {
            GALLERY: "Gallery",
            CAMERA: "Camera"
        },
        OPTIONAL: "Optional",
        CANCEL: "Cancel",
        CONFIRM: "Confirm"
    }
}